function changeTheme(newTheme) {
  document.documentElement.className = newTheme;
}

export default changeTheme;
